export default "__VITE_ASSET__604dc4c5__"